module.exports = __webpack_public_path__ + "static/media/Mommies Daily.8707bf0f.PNG";